import type { JSX } from 'react';

import { ChevronLeftIcon } from '@change/ds-icons';

import { Link, Separator, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

type Props = {
	slug: string;
	onClick?: () => void;
};

export function StarterDashboardNavLink({ slug, onClick }: Props): JSX.Element | null {
	return (
		<>
			<div className="container">
				<Link href={`/p/${slug}/dashboard`} variant="secondary" onClick={onClick}>
					<Text className="text-typography-strong inline-flex items-center gap-2 py-4">
						<ChevronLeftIcon />
						<Translate value="fe.components.petition_manage.starter_navigation.back_link" />
					</Text>
				</Link>
			</div>
			<Separator />
		</>
	);
}
